import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  CtxAlertComponent,
  CtxButtonComponent,
  CtxButtonGroupComponent,
  CtxDynamicForm,
  UNLIMITED_VALUE_MINUS_ONE,
} from 'ng-ui';
import {
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CtxStepperComponent } from 'ng-ui';

import {
  CtxValidators,
  ResourceCreateFormData,
  ResourceUpdateDynamicFormData,
  originalOrder,
} from 'utils';
import { ALL_COUNTRIES } from 'utils';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatSelectModule } from '@angular/material/select';
import { CtxStepComponent } from '../stepper/step/step.component';

@Component({
  selector: 'ctx-organization-form',
  templateUrl: './organization-form.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    CtxButtonComponent,
    ReactiveFormsModule,
    MatTooltipModule,
    CtxButtonGroupComponent,
    MatCheckboxModule,
    MatSelectModule,
    MatDialogModule,
    CtxAlertComponent,
    CtxStepComponent,
    CtxStepperComponent,
  ],
})
export class OrganizationFormComponent
  extends CtxDynamicForm
  implements OnInit
{
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public dialogData: ResourceCreateFormData | ResourceUpdateDynamicFormData,
    public dialogRef: MatDialogRef<OrganizationFormComponent>,
    fb: FormBuilder
  ) {
    super(fb);
  }
  /**  */
  @ViewChild(CtxStepperComponent) ctxTab: CtxStepperComponent;

  ALL_COUNTRIES = ALL_COUNTRIES;

  /**
   * Controls that handle tab validation
   */
  detailsTab: FormControl;
  addressTab: FormControl;
  originalOrder = originalOrder;
  UNLIMITED_VALUE_MINUS_ONE = UNLIMITED_VALUE_MINUS_ONE;
  ngOnInit(): void {
    this.formGroup = this.fb.group({
      name: [
        this.getInitialControlValue('name', this.dialogData),
        [Validators.maxLength(256), Validators.required],
      ],
      email: [
        this.getInitialControlValue('email', this.dialogData),
        Validators.email,
      ],
      description: [
        this.getInitialControlValue('description', this.dialogData),
        Validators.maxLength(256),
      ],
      allowedUsers: [
        this.getInitialControlValue('allowedUsers', this.dialogData),
        [
          Validators.required,
          Validators.min(-1),
          CtxValidators.int32,
          CtxValidators.onlyIntegers,
        ],
      ],
      address: this.fb.group({
        addressLine1: [
          this.getInitialControlValue('address.addressLine1', this.dialogData),
          Validators.maxLength(256),
        ],
        addressLine2: [
          this.getInitialControlValue('address.addressLine2', this.dialogData),
          Validators.maxLength(256),
        ],
        city: [
          this.getInitialControlValue('address.city', this.dialogData),
          Validators.maxLength(256),
        ],
        state: [
          this.getInitialControlValue('address.state', this.dialogData),
          Validators.maxLength(256),
        ],
        country: [
          this.getInitialControlValue('address.country', this.dialogData),
          Validators.maxLength(256),
        ],
        postalCode: [
          this.getInitialControlValue('address.postalCode', this.dialogData),
          Validators.maxLength(256),
        ],
      }),
    });
    /**
     * Create a separate group to validate tabs.
     */
    this.detailsTab = this.fb.control([
      this.formGroup.get('name'),
      this.formGroup.get('email'),
      this.formGroup.get('description'),
    ]);
    this.addressTab = this.fb.control([this.formGroup.get('address')]);
  }
}
